export default {
  AssetTypeName: "Loại tài sản",
  AssetCategoryName: "Nhóm tài sản",
  Description: "Ghi chú",
  AddAssetTypeButton: "Thêm loại tài sản",
  Detail: {
    AddTitle: "Thêm mới loại tài sản",
    EditTitle: "Sửa loại tài sản",
    AssetTypeName: "Tên loại tài sản",
    AssetCategory: "Nhóm tài sản",
    Description: "Ghi chú",
    AssetTypeCode: "Mã loại tài sản",
    ManagementType: "Cách quản lý",
    ManagementByCode: "Quản lý theo mã",
    ManagementByQuantity: "Quản lý theo số lượng",
    Inactive: "Ngừng sử dụng",
    Prefix: "Tiền tố",
    Suffixes: "Hậu tố",
    Max: "Tối đa",
    IsTrackWarranty: "Bảo hành",
    Warranty: "Được bảo hành",
    Nowarranty: "Không có bảo hành",
    IsMaintenance: "Bảo dưỡng",
    Maintaince: "Bảo dưỡng định kỳ",
    Nomaintance: "Không bảo dưỡng",
    CodegenerateType: "Cách đánh mã",
    ConfirmMessageChangeIsTrackQuantity:
      "Bạn không được phép sửa cách quản lý của Loại tài sản đã phát sinh tài sản.",
    ConfirmMessageInactive:
      "Loại tài sản này đã có phát sinh tài sản. Bạn có chắc chắn muốn ngừng sử dụng Loại tài sản này không?",
  },
  Search: {
    Title: "Loại tài sản",
  },
};
